/**
 * Represents a data source record for multidimensional allocation worksheets
 * Contains both API data and UI state for managing data source configuration
 */
export interface MultiAllocationDataSourceRecord {
    datasourceId: string,
    unsavedDatasourceId: string,
    worksheetId: string,
    worksheetVersion: number,
    datasource: string,
    period: string,
    balancePullInProgress: boolean,
    customPeriod: string,
    fxDate: string,
    fxType: string,
    fxRate: string,
    currency: string,
    dataKey: string,
    description: string,
    startPeriod: string,
    endPeriod: string
    createUser: string,
    createdDate: number,
    lastModifiedUser: string,
    lastModifiedDate: number,
    allocationSegment?: string,
    allocationSheetId?: string,
    allocationSheetVersion?: number,
    worksheetName?: string,
    lastBalancePullId?: string,
    lastBalancePullDate?: number,
    balancePullStatus?: string,
    s3PresignUrl?: string,
    dataKeyInput?: {
        selectedCompanies: string,
        selectedAccounts: string,
        selectedCOA: Map<string, string>,
    },
    isNewRecord: boolean,
    errors: Map<string, string> | undefined,
    isEditing: boolean,
    showDataKeySelection: boolean
}

/**
 * Creates a new multidimensional allocation data source record with default values
 * @param recordIdCounter - Counter for generating unique record IDs
 * @returns New data source record initialized for editing
 */
export const getNewMultiAllocationDataSourceRecord = (recordIdCounter: number) => {
    return {
        datasourceId: String(recordIdCounter),
        isEditing: true,
        balancePullInProgress: false,
        dataKeyInput: {
            selectedCompanies: '',
            selectedAccounts: '',
            selectedCOA: new Map<string, string>(),
        },
        isNewRecord: true,
    } as unknown as MultiAllocationDataSourceRecord
}
